import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';
import { ResultStatus, TestRunSource } from '../../models/test-run.model';
import { ReleaseResultsFilters } from '../../models/release-results.model';

/** Filter shape of the test-results overview, serialized into `SavedView.filtersJson` (NEX-788). */
export interface TestResultsSavedViewFilters {
  env: string;
  system: string;
  result: ResultStatus | 'all';
}

const EMPTY_TEST_RESULTS_SAVED_VIEW_FILTERS: TestResultsSavedViewFilters = {
  env: 'all',
  system: 'all',
  result: 'all',
};

export function parseTestResultsSavedViewFilters(filtersJson: string | null): TestResultsSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_TEST_RESULTS_SAVED_VIEW_FILTERS);
}

export function buildTestResultsSavedViewFiltersJson(filters: TestResultsSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}

/** Seitenfilter für die Release-Endpunkte; Freigabe-Karte und Sicht „Testpläne" zählen damit dieselben Läufe. */
export function releaseResultsFilters(environment: string | null, source: TestRunSource | null): ReleaseResultsFilters {
  const filters: ReleaseResultsFilters = {};
  if (environment) filters.environment = environment;
  if (source) filters.source = source;
  return filters;
}

export type PassRateTone = 'good' | 'warn' | 'bad';

export function passRateTone(rate: number): PassRateTone {
  if (rate >= 90) return 'good';
  if (rate >= 75) return 'warn';
  return 'bad';
}
